export default "<header>\n  <h1>TodoList</h1>\n  <nav>\n    <a routerLink=\"/\">Home</a> | \n    <a routerLink=\"/about\">About</a>\n  </nav>\n</header>"